import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BackgroundCheckNavLink from './BackgroundCheckNavLink';
import RentalApplicationNavLink from './RentalApplicationNavLink';
import CreditReportNavLink from './CreditReportNavLink';
import { and } from 'airbnb-prop-types';
import { passthroughProp } from '../../../../../utils/propTypes';
import { isBackgroundReportLoadingSelector, isCreditReportLoadingSelector } from '../../../../../selectors';
import { updateReportsLoadingStatuses } from '../../../../../actions/loadingStatusActionCreators';
import IcraaPageConfigProvider from '../../../../../contexts/providers/IcraaPageConfigProvider';
import IcraaComplianceWall from './LegalComplianceWall/IcraaComplianceWall';

export default function ApplicantNavLinks({ applicant }) {
  const dispatch = useDispatch();
  const isBackgroundReportLoading = useSelector(isBackgroundReportLoadingSelector);
  const isCreditReportLoading = useSelector(isCreditReportLoadingSelector);
  const [backgroundNavigationCallback, setBackgroundNavigationCallback] = useState(null);
  const [creditNavigationCallback, setCreditNavigationCallback] = useState(null);

  function onCancelCleanupScreening() {
    /**
     * If user cancels out of modal without accepting legal compliance,
     * re-enable view buttons if disabled for legal compliance.
     */
    dispatch(
      updateReportsLoadingStatuses({
        creditReportLoading: false,
        backgroundReportLoading: false,
      }),
    );
    setBackgroundNavigationCallback(null);
    setCreditNavigationCallback(null);
  }

  const applicantSection = (
    <div className="ApplicantSection">
      <RentalApplicationNavLink applicant={applicant} />
      <CreditReportNavLink
        {...{
          applicant,
          isCustomLoading: isCreditReportLoading,
          customNavigationCallback: creditNavigationCallback,
          setCustomNavigationCallback: setCreditNavigationCallback,
        }}
      />
      <BackgroundCheckNavLink
        {...{
          applicant,
          isCustomLoading: isBackgroundReportLoading,
          customNavigationCallback: backgroundNavigationCallback,
          setCustomNavigationCallback: setBackgroundNavigationCallback,
        }}
      />
    </div>
  );

  return (
    <IcraaPageConfigProvider applicant={applicant}>
      {applicantSection}
      <IcraaComplianceWall {...{ applicant, onCancelCleanupScreening }} />
    </IcraaPageConfigProvider>
  );
}

ApplicantNavLinks.propTypes = {
  applicant: and([
    passthroughProp(RentalApplicationNavLink),
    passthroughProp(CreditReportNavLink),
    passthroughProp(BackgroundCheckNavLink),
    passthroughProp(IcraaPageConfigProvider),
  ]),
};
